<div class="dialog delete">
    <div *ngIf="showAlert" mat-dialog-title style="text-align: center;">
        <span #dialogTitle id="mct-alert-title" tabindex="-1" role="heading" aria-level="1">MCT Authentication Alert</span>
    </div>
    <mat-divider *ngIf="showAlert"></mat-divider>
    <div *ngIf="!showAlert" mat-dialog-title style="text-align: center;">
        <span style="text-align:center;font-weight:700;font-size:22px;font-family:'Plus Jakarta Sans' !important">Important Update: MCT Portal Login Requirements</span>
    </div>
    <!-- <div style="display: flex;
        justify-content: center;">
    <fa-icon style="font-size:20px" *ngIf="!showAlert" [icon]="icons.faUserLock"></fa-icon>
    </div> -->
  <mat-dialog-content>
    <p style="white-space: pre-wrap" [innerHTML]="safeHtmlContent"></p>
    </mat-dialog-content>

    <div *ngIf="data.caseScenario == 1" mat-dialog-actions  style="display: flex;
        justify-content: center;">
        <div>
            <button mat-raised-button color="primary" (click)="loginAction()">Sign-In again</button>
        </div>
    </div>
</div>